export const GET_ASSIGNED_LIST = "GET_ASSIGNED_LIST";
export const GET_SERVICE_PROVIDER = "GET_SERVICE_PROVIDER";
